export default "__VITE_PUBLIC_ASSET__5dc297b1__"